import LoginCard from "./LoginCard";

export default LoginCard;
